var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavorite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.28074 1.3386C6.43766 0.887135 7.07614 0.887134 7.23307 1.3386L8.30105 4.41106C8.37028 4.61022 8.55614 4.74526 8.76695 4.74956L12.0191 4.81583C12.4969 4.82557 12.6942 5.43279 12.3134 5.72155L9.72129 7.68671C9.55327 7.81409 9.48228 8.03259 9.54333 8.2344L10.4853 11.3478C10.6237 11.8053 10.1071 12.1806 9.71481 11.9076L7.04484 10.0497C6.87177 9.92923 6.64203 9.92923 6.46896 10.0497L3.79899 11.9076C3.40667 12.1806 2.89013 11.8053 3.02854 11.3478L3.97047 8.2344C4.03153 8.03259 3.96053 7.81409 3.79251 7.68671L1.20045 5.72155C0.819578 5.43279 1.01688 4.82557 1.49474 4.81583L4.74685 4.74956C4.95766 4.74526 5.14352 4.61022 5.21275 4.41106L6.28074 1.3386Z",
    fill: "black",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorite);
export default __webpack_public_path__ + "static/media/favorite.7824957872dbd497c88efa33abf6adce.svg";
export { ForwardRef as ReactComponent };